import styled from "styled-components";
import { RATypography, RAButtonPrimary, RAButtonSecondary } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Row, Col } from "antd";
import { SvgInfoFill, SvgArrowLeft } from "@/assets/icons";
import { IconDuplicationWarning } from "@/assets/images";

export function FormWarning({ onContinue, onReview, onBack }) {
	return (
		<ContainerRequestFlight data-testid="DuplicateWarning_content">
			<Row align="middle" justify="center" style={{ marginBottom: 24 }}>
				<RAImage url={IconDuplicationWarning} width={52} height={52} />
			</Row>
			<Row align="middle" justify="center" style={{ marginBottom: 8, textAlign: "center" }}>
				<RATypography variant="h4">Potential Duplicate Alert Detected</RATypography>
			</Row>
			<Row align="middle" justify="center" style={{ textAlign: "center", marginBottom: 20 }}>
				<RATypography variant="body3" color="#595959">
					You&apos;re creating an Empty Leg Alert for an airport within 40 miles of another airport already on
					your alert list.
				</RATypography>
			</Row>
			<Row
				align="top"
				justify="center"
				wrap={false}
				style={{
					padding: 16,
					background: "#F9F9F9",
					borderRadius: 8,
					marginBottom: 30,
				}}
				gutter={12}
			>
				<Col>
					<IconContainer>
						<SvgInfoFill color="#FFB11A" />
					</IconContainer>
				</Col>
				<Col>
					<RATypography variant="body3" color="#595959">
						Due to the unique way our system functions, creating alerts for airports in close proximity may
						not be necessary.
					</RATypography>
				</Col>
			</Row>
			<Row style={{ marginBottom: 16 }} gutter={[16, 16]} align="middle" justify="center">
				<Col>
					<RAButtonSecondary
						data-testid="DuplicateWarning_continueBtn"
						title="CONTINUE ANYWAY"
						onClick={() => onContinue?.()}
						// width="160px"
					/>
				</Col>
				<Col>
					<RAButtonPrimary
						data-testid="DuplicateWarning_reviewBtn"
						title="REVIEW MY ALERTS"
						onClick={() => onReview?.()}
						// width="160px"
					/>
				</Col>
			</Row>
			<Row justify="center" align="middle">
				<BackButton data-testid="DuplicateWarning_backBtn" onClick={() => onBack?.()}>
					<SvgArrowLeft color={"#A8A8A8"} style={{ marginRight: 8 }} />
					<RATypography variant="button1">BACK</RATypography>
				</BackButton>
			</Row>
		</ContainerRequestFlight>
	);
}

const ContainerRequestFlight = styled.div`
	width: "100%";
	padding: 30px 30px 30px 30px;
	@media (max-width: 576px) {
		padding: 0;
	}
`;

const IconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px;
	background-color: #f3f2f2;
	border-radius: 50%;
`;

const BackButton = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	border-radius: 50px;
	padding: 17px 28px;
	height: 44px;
`;
